exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".UploadImageBtnField{display:flex;flex-direction:column}.UploadImageBtnField label{font-size:14px;color:rgba(0,0,0,.65);font-weight:700}.UploadImageBtnField .blockActions{align-items:center;justify-content:flex-start;margin-bottom:20px;display:flex}.UploadImageBtnField .blockActions label{font-weight:400!important}.UploadImageBtnField .blockActions .btn-primary{background-color:#00adff!important;border:1px solid #00adff!important;color:#fff!important;border-radius:20px!important}.UploadImageBtnField .blockActions .btn{margin:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./yii2/frontend/frontend-assets/src/components/helpers/Fields/UploadImageBtnField.scss
// module id = 4891
// module chunks = 0